import { render, staticRenderFns } from "./IntegrationsMenu.vue?vue&type=template&id=20206303&scoped=true&"
import script from "./IntegrationsMenu.vue?vue&type=script&lang=ts&"
export * from "./IntegrationsMenu.vue?vue&type=script&lang=ts&"
import style0 from "@/assets/less/manage-space/base.less?vue&type=style&index=0&id=20206303&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20206303",
  null
  
)

export default component.exports